import { GTM_SCRIPT_TAG_ID } from './ensureGTMScriptAdded';

export const removeGTMScript = () => {
  const elem = document.getElementById(GTM_SCRIPT_TAG_ID);
  if (elem) {
    document.body.removeChild(elem);
  }
};
